<template>
  <v-dialog v-model="open" persistent max-width="500px">
    <v-card>
      <v-card-title>
        <span>{{ $T('common.change_attribute', { attr: $T('attributes.genre') }) }}</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-container grid-list-lg text-xs-left>
        <v-layout column wrap>
          <v-flex>
            <v-select
              data-vv-name="genre"
              :items="$commin.countryGenres()"
              item-text="value"
              item-value="key"
              ref="input_genre"
              :label="$T('attributes.genre')"
              v-model="genre"
              color="clr-primary"
              v-validate="'required'"
              :error-messages="getMessage('genre')"
              required
              :disabled="loading"
            ></v-select>
          </v-flex>
          <v-flex>
            <v-select
              data-vv-name="sub_genre"
              :items="$commin.countryGenres(genre).subGenres"
              item-text="value"
              item-value="key"
              ref="'input_sub_genre'"
              :label="$T('attributes.sub_genre')"
              v-model="sub_genre"
              color="clr-primary"
              v-validate="'required'"
              :error-messages="getMessage('sub_genre')"
              required
              :disabled="loading"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="clr-btn-cancel" flat @click.native="close">{{ $T('button.close') }}</v-btn>
        <v-btn color="clr-btn" flat @click.native="save" :disabled="!isSavable" :loading="loading">{{
          $T('button.save')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    initValue: { type: Object, required: true },
  },
  data() {
    return {
      genre: null,
      sub_genre: null,
      open: false,
      loading: false,
      apiErrors: {},
    };
  },
  watch: {
    genre: function(newValue, oldValue) {
      if (oldValue != null) {
        this.sub_genre = null;
      }
    },
  },
  computed: {
    isSavable() {
      return this.isFormDirty && !this.isFormInValid && !this.loading;
    },
    isFormDirty() {
      return Object.keys(this.fields).some(key => this.fields[key].dirty);
    },
    isFormInValid() {
      return Object.keys(this.fields).some(key => this.fields[key].invalid);
    },
  },
  methods: {
    openDialog() {
      this.genre = this.initValue.genre;
      this.fields.genre.invalid = false;
      this.sub_genre = this.initValue.sub_genre;
      this.fields.sub_genre.invalid = false;
      this.open = true;
    },
    getMessage(fieldName) {
      return this.apiErrors[fieldName] && this.apiErrors[fieldName][this.inputValue]
        ? this.apiErrors[fieldName][this.inputValue]
        : this.errors.collect(fieldName);
    },
    reValidate() {
      this.$validator.validateAll();
      this.$refs['input_' + this.fieldName].focus();
      this.loading = false;
    },
    close() {
      this.open = false;
      this.loading = false;
    },
    save() {
      this.loading = true;
      var _self = this;
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit('save', 'genre', { genre: this.genre, sub_genre: this.sub_genre }, this.initValue);
        } else {
          _self.loading = false;
          console.warn('there is invalid values.');
        }
      });
    },
  },
};
</script>

<style scoped>
.container {
  padding: 0px 24px 12px 24px;
}
</style>
